import * as React from "react"
import "./notfound.scss"

const Notfound: React.FC = () => {
	return (
		<div>
			<h1>یافت نشد</h1>
		</div>
	)
}

export default Notfound
